document.addEventListener('DOMContentLoaded', function() {
  const deliveryTimes = {
    "Abu Dhabi": "3-4 Business Days",
    "Dubai": "1-2 Business Days",
    "Sharjah": "1-2 Business Days",
    " Umm Al Qaiwain": "3-4 Business Days",
    "Fujairah": "3-4 Business Days",
    "Ajman": "1-2 Business Days",
    "Ras Al Khaimah": "4-5 Business Days"
  };

  const stateSelect = document.getElementById('state-select');
  const deliveryElement = document.getElementById('delivery-time');
  const estimateSpan = document.getElementById('delivery-estimate');

  if (stateSelect) {
    stateSelect.addEventListener('change', function() {
      const state = this.value;
      if (state && deliveryTimes[state]) {
        estimateSpan.textContent = deliveryTimes[state];
        deliveryElement.style.display = 'block';
      } else {
        deliveryElement.style.display = 'none';
      }
    });
  }
});
